import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import {Menu , MenuDivider, MenuItem,Button, Icon}from '@blueprintjs/core';
import { Example, IExampleProps } from "@blueprintjs/docs-theme";
import { Popover2 } from "@blueprintjs/popover2";
import { Breadcrumbs, Classes,Intent, ITreeNode, Tree } from "@blueprintjs/core";


@inject("store")
@observer
export default class StarLabel extends Component
{
    constructor(props) {
        super(props);
        this.state = {  };
        this.getstar = this.getstar.bind(this);
    }

  /* componentDidMount() {
      this.timerID = setInterval(
          () => this.tick(),
          3000
        );
      }

      componentWillUnmount() {
        clearInterval(this.timerID);
      }

      tick(){
        if(this.props.store.starchange!=0){
            this.forceUpdate();
            this.props.store.starchange = 0;
           
        }
      }
  */

    getstar(notepath){
        let notenumber = this.props.store.getnotelistnumber(notepath);
        const notenames = this.props.store.getnotelistname(notepath);

        let addnumber = 0 ;
        if(notenumber)
        notenames.forEach(element => {
           let star= localStorage.getItem(element+"star");
        //   window.confirm(star)
           switch (star){
            case "完美" :
                addnumber +=5;
                break;
            case "挺好" :
                    addnumber +=4;
                 break; 
            case "还行" :
                    addnumber +=3;
                 break; 
            case "较差" :
                    addnumber +=2;
                 break; 
            case "很差" :
                    addnumber +=1;
                 break; 
            
           }
        });
     //   window.confirm(addnumber);
        let average =  Math.round(addnumber/notenumber);
      
        //window.confirm(average);
     
        return average;
        
    }

  
   

    update(){
        if(this.props.store.starchange!=0){
            this.forceUpdate();
            this.props.store.starchange = 0;
        }
    }

    render()
    {
        
        let arruse = [];
        if(this.getstar(this.props.notepath)>=1){
            arruse.length = this.getstar(this.props.notepath);
            arruse.fill('2');
        }
       
        
        
       
        return <div onClick={()=>this.update()}>
            
           {arruse!=null &&arruse.map(item =>  <Icon icon = "star" intent = {Intent.PRIMARY} />)}
          
            </div>;
    }
}